/**
 * 获取全量数据的分页参数
 * 场景：接口支持分页，但是考虑到全量数据不多的情况下，暂时采用前端分页时，拉取数据接口的入参中分页参数就可以统一使用这个常量
 */
export const PAGINATION_FETCH_PARAMS: IPaginationFetchParams = {
  page: 1,
  // 接口分页，前端不分页，这里固定传9999即可，因为国家不太可能超过9999个
  page_size: 9999,
};

/**
 * GSD Publisher Shared筛选器的默认值
 */
export const DEFAULT_GSD_TYPE = 'all';

/**
 * 下载配置的字段常量配置
 */
export const DOWNLOAD_CFG_KEY = {
  /**
   * Edition Settings
   */
  EDITION_METHOD: 'edition_method',
  /**
   * Time Settings
   */
  DATE_METHOD: 'date_method',
  /**
   * Region Settings
   */
  REGION_METHOD: 'region_method',
  /**
   * Genre Settings
   */
  GENRE_METHOD: 'genre_method',
  /**
   * Data Amount
   */
  DATA_METHOD: 'data_method',
  /**
   * Select Top
   */
  SELECT_TOP: 'select_top',
};
